import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const AssetsTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'number', text: t('assets.fields.number') + ': ', type: 'h3' },
    { variable: 'name', text: t('assets.fields.name') + ': ' },
    {
      parent: '_costCenter',
      variable: 'key',
      text: t('assets.fields.costCenter') + ' Llave: ',
    },
    {
      parent: '_costCenter',
      variable: 'name',
      text: t('assets.fields.costCenter') + ' Nombre: ',
    },
    {
      parent: '_account',
      variable: 'name',
      text: t('assets.fields.account') + ' Cuenta: ',
    },
    {
      parent: '_account',
      variable: 'name',
      text: t('assets.fields.account') + ' Cuenta: ',
    },
    { variable: 'buyDate', text: t('assets.fields.buyDate') + ': ' },
    { variable: 'startDate', text: t('assets.fields.startDate') + ': ' }, //falta
    {
      variable: 'name',
      isDepreciation: true,
      text: t('assets.fields.depreciationName') + ': ',
    },
    { variable: 'price', number: true, text: t('assets.fields.price') + ': ' },
    {
      variable: 'totalLifeYears',
      isDepreciation: true,
      number: true,
      presicion: 4,
      text: t('assets.fields.lifeTime') + ': ',
    },
    { variable: 'currentMonthDep', number: true, text: t('assets.fields.currentMonthDep') + ': ' },
    {
      variable: 'totalMonthYearsDep',
      number: true,
      text: t('assets.fields.totalMonthYearsDep') + ': ',
    },
    {
      variable: 'totalMonthYearsDepAct',
      number: true,
      text: t('assets.fields.totalMonthYearsDepAct') + ': ',
    },
    { variable: 'totalMonthLife', number: true, text: t('assets.fields.totalMonthLife') + ': ' },
    {
      variable: 'lifeYears',
      isDepreciation: true,
      number: true,
      presicion: 4,
      text: t('assets.fields.remainingLife') + ': ',
    },
    {
      variable: 'originalAmount',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.moi') + ': ',
    },
    {
      variable: 'lastPeriodDepreciation',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.lastDepreciation') + ': ',
    },
    {
      variable: 'currentNormalDepreciation',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.currentDepreciation') + ': ',
    },
    { variable: 'monthlyDep', number: true, text: t('assets.fields.monthlyDep') + ': ' },
    {
      parent: 'factors',
      variable: 'inpcBegin',
      isDepreciation: true,
      text: t('assets.fields.inpcStart') + ': ',
    },
    {
      parent: 'factors',
      variable: 'inpcEnd',
      isDepreciation: true,
      text: t('assets.fields.inpcEnd') + ': ',
    },
    {
      parent: 'factors',
      variable: 'factor',
      isDepreciation: true,
      text: t('assets.fields.factor') + ': ',
    },
    {
      variable: 'currentDepreciation',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.lastDepreciationRecalculated') + ': ',
    },
    {
      variable: 'totalDepreciation',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.totalDepreciation') + ': ',
    },
    {
      variable: 'depreciable',
      isDepreciation: true,
      number: true,
      text: t('assets.fields.depreciable') + ': ',
    },
  ];

  const config = {
    noActions: true,
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.assets.update.NoTiene',
    togglePermission: 'acl.assets.toggle.NoTiene',
    editUrl: 'assets', //Url para editar empleado
    propsName: 'asset', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="number"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.number')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="brand"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.brand')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="model"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.model')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="serie"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.serie')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_costCenter.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.costCenter')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_account.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.accountKey')}
          </Common.ThSortable>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_account.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.account')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="buyDate"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.buyDate')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="startDate"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.startDate')}
          </Common.ThSortable>
          <th>{t('assets.fields.depreciationName')}</th>
          <th>{t('assets.fields.price')}</th>
          <th>{t('assets.fields.priceDollars')}</th>
          <th>{t('assets.fields.lifeTime')}</th>
          <th>{t('assets.fields.currentMonthDep')}</th>
          <th>{t('assets.fields.totalMonthYearsDep')}</th>
          <th>{t('assets.fields.totalMonthYearsDepAct')}</th>
          <th>{t('assets.fields.totalMonthLife')}</th>
          <th>{t('assets.fields.remainingLife')}</th>
          <th>{t('assets.fields.moi')}</th>
          <th>{t('assets.fields.lastDepreciation')}</th>
          <th>{t('assets.fields.currentDepreciation')}</th>
          <th>{t('assets.fields.monthlyDep')}</th>
          <th>{t('assets.fields.monthlyDepDollars')}</th>
          <th>{t('assets.fields.inpcStart')}</th>
          <th>{t('assets.fields.inpcEnd')}</th>
          <th>{t('assets.fields.factor')}</th>
          <th>{t('assets.fields.lastDepreciationRecalculated')}</th>
          <th>{t('assets.fields.totalDepreciation')}</th>
          <th>{t('assets.fields.depreciable')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={18} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(AssetsTable);



// WEBPACK FOOTER //
// src/components/reports/depreciation/ReportsDepreciationTable.js